import { Injectable } from '@angular/core';

import { ProductCarpetSpec } from '../../../models';
import { TmsWebBaseEditService } from '../../base';

@Injectable({
  providedIn: 'root',
})
export class ProductCarpetSpecService extends TmsWebBaseEditService<ProductCarpetSpec, ProductCarpetSpec> {
  constructor() {
    super('CarpetSpec', $localize`Carpet Spec`);
  }
}
